import { render } from "./OrderedMultiSelect.vue?vue&type=template&id=20bf700d"
import script from "./OrderedMultiSelect.vue?vue&type=script&lang=js"
export * from "./OrderedMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__